import { isEmpty } from 'lodash';
import { Grid } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MemberPromoCode from '../../MemberPromoCode';
import InputWithButton from '../../../MUI/InputWithButton';

const MobileComponents = ({
  promoCode,
  newPromoCode,
  setNewPromoCode,
  removeAppliedPromoCode,
  submitPromoCode,
  showPromoInput,
  setShowPromoInput,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {!showPromoInput && !isEmpty(promoCode) ? (
        <Grid item xl={6} xs={4}>
          <MemberPromoCode
            policyNumber={promoCode.policyNumber}
            setShowPromoInput={setShowPromoInput}
            showPromoInput={showPromoInput}
            removeAppliedPromoCode={removeAppliedPromoCode}
          />
        </Grid>
      ) : (
        <Grid item xl={6} xs={8}>
          <InputWithButton
            placeholder={t('promoCode.addPromoCode')}
            value={newPromoCode}
            onChange={setNewPromoCode}
            handleClick={submitPromoCode}
          />
        </Grid>
      )}
    </>
  );
};

MobileComponents.propTypes = {

  promoCode: PropTypes.shape({
    policyNumber: PropTypes.string,
  }),
  setNewPromoCode: PropTypes.func.isRequired,
  removeAppliedPromoCode: PropTypes.func.isRequired,
  submitPromoCode: PropTypes.func.isRequired,
  newPromoCode: PropTypes.string,
  showPromoInput: PropTypes.bool.isRequired,
  setShowPromoInput: PropTypes.func.isRequired,
};

MobileComponents.defaultProps = {
  newPromoCode: undefined,
  promoCode: {},
};

export default MobileComponents;
